import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Search, Loader2 } from "lucide-react";
import { checkPincode } from "../api";

export default function PinChecker({ compact = false, onResult, autoRedirect = false }) {
  const nav = useNavigate();
  const [pin, setPin] = useState("");
  const [state, setState] = useState({ loading: false, ok: null, msg: "" });

  const submit = async (e) => {
    e?.preventDefault();
    if (!/^[0-9]{6}$/.test(pin)) {
      setState({ loading: false, ok: false, msg: "Please enter a valid 6-digit PIN code." });
      return;
    }
    setState({ loading: true, ok: null, msg: "" });
    try {
      const r = await checkPincode(pin);
      setState({ loading: false, ok: r.serviceable, msg: r.message });
      onResult?.(r);
      if (autoRedirect && r.serviceable) {
        setTimeout(() => nav(`/book-service?pin=${pin}`), 700);
      }
    } catch (err) {
      setState({ loading: false, ok: false, msg: "Something went wrong. Please try again." });
    }
  };

  return (
    <div className={compact ? "" : "bg-white p-6 md:p-7 rounded-lg border border-neutral-200 shadow-sm"}>
      {!compact && (
        <div className="mb-4">
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#e30613] font-semibold mb-1">PIN Code Check</div>
          <div className="font-display text-2xl md:text-3xl font-medium">Do we service your area?</div>
        </div>
      )}
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))}
          placeholder="Enter your 6-digit PIN"
          inputMode="numeric"
          className="field flex-1"
          aria-label="Enter your 6-digit PIN code"
        />
        <button type="submit" disabled={state.loading} className="btn-primary justify-center">
          {state.loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
          Check
        </button>
      </form>
      {state.ok === true && (
        <div className="mt-4 flex items-start gap-2.5 p-3.5 bg-green-50 border border-green-200 rounded">
          <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
          <div>
            <div className="font-semibold text-green-800 text-sm">Service Available</div>
            <div className="text-green-700 text-sm">{state.msg}</div>
          </div>
        </div>
      )}
      {state.ok === false && (
        <div className="mt-4 flex items-start gap-2.5 p-3.5 bg-red-50 border border-red-200 rounded">
          <XCircle className="w-5 h-5 text-[#e30613] flex-shrink-0 mt-0.5" />
          <div>
            <div className="font-semibold text-[#b8050f] text-sm">Not Serviceable</div>
            <div className="text-[#b8050f]/90 text-sm">{state.msg}</div>
          </div>
        </div>
      )}
    </div>
  );
}
